import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MonitorMobbileIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M16.8 2H6.21001C3.89001 2 2.01001 3.88 2.01001 6.19V12.37V12.56C2.01001 14.88 3.89001 16.75 6.20001 16.75H9.80001C10.35 16.75 10.8 17.2 10.8 17.75V18.57C10.8 19.12 10.35 19.57 9.80001 19.57H7.55001C7.16001 19.57 6.84001 19.89 6.84001 20.28C6.84001 20.67 7.16001 20.99 7.55001 20.99H15.48C15.87 20.99 16.19 20.67 16.19 20.28C16.19 19.89 15.87 19.57 15.48 19.57H13.23C12.68 19.57 12.23 19.12 12.23 18.57V17.75C12.23 17.2 12.68 16.75 13.23 16.75H16.8C19.12 16.75 20.99 14.87 20.99 12.56V12.37V6.19C20.99 3.88 19.11 2 16.8 2Z",
      fill: _ctx.color || '#7E8695'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M19.64 9.5H14.35C12.62 9.5 11.99 10.13 11.99 11.88V19.61C11.99 21.37 12.61 21.99 14.35 21.99H19.64C21.37 21.99 22 21.36 22 19.61V11.88C22 10.12 21.38 9.5 19.64 9.5ZM17 20.32C16.39 20.32 15.9 19.83 15.9 19.22C15.9 18.61 16.39 18.12 17 18.12C17.61 18.12 18.1 18.61 18.1 19.22C18.1 19.83 17.61 20.32 17 20.32Z",
      fill: _ctx.color || '#7E8695'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M18.0999 19.22C18.0999 19.83 17.6099 20.32 16.9999 20.32C16.3899 20.32 15.8999 19.83 15.8999 19.22C15.8999 18.61 16.3899 18.12 16.9999 18.12C17.6099 18.12 18.0999 18.62 18.0999 19.22Z",
      fill: _ctx.color || '#7E8695'
    }, null, 8, _hoisted_4)
  ]))
}
}

})